import React from 'react';
import { TableCell as BaseTableCell, TableCellProps } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withClassNames from './withClassNames';

const TableCell = withClassNames<TableCellProps>(BaseTableCell);

export type DataGridCellProps = TableCellProps & {
  ref?: React.RefObject<HTMLTableRowElement | HTMLTableCellElement>;
}

// Hack around propTypes breaking generic interfaces
type DataGridCellComponent = {
  (props: DataGridCellProps): React.JSX.Element;
  // eslint-disable-next-line @typescript-eslint/ban-types
  propTypes?: {};
  displayName: string;
};

// Ugly hack to merge classNames with base TableCell
export const DataGridCell: DataGridCellComponent = (props: DataGridCellProps) => {
  const { className, component, ...rest } = props;

  return (
    <TableCell
      {...rest}
      ref={props.ref}
      component={component}
      className={classNames(props.className, className)}
    />
  );
};

DataGridCell.propTypes = {
  className: PropTypes.string,
  // @ts-ignore
  component: PropTypes.elementType
// Typescript overrides types for props when types include a generic interface and propTypes are passed
// eslint-disable-next-line @typescript-eslint/ban-types
} as {};

DataGridCell.displayName = 'DataGridCell';
